import React, { useState, useEffect } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { PREFIX } from '../../../../Config';
import { fetchProformaInvoice } from '../../../../../utils/proformaInvoiceApi';

const SalesInvoice = () => {
    const [invoiceData, setInvoiceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem('token');
    useEffect(() => {
        fetchInvoiceData();
    }, []);

    useEffect(() => {
        if (invoiceData && !loading) {
            generatePDF();
        }
    }, [invoiceData, loading]);

    const fetchInvoiceData = async () => {
        try {
            const data = await fetchProformaInvoice('571', token);

            if (data.success) {
                setInvoiceData(data.details);
            }
        } catch (error) {
            setSampleData();
        } finally {
            setLoading(false);
        }
    };

    const setSampleData = () => {
        setInvoiceData({
            shop_details: {
                shop_name: "Ebusso",
                address: "Aundh Pune - 411007 | Aylesford, England - ME20 6SW",
                phone: "447585591189",
                email: "sales@ebusso.com",
                website: "www.ebusso.com",
                company_reg_no: "0101",
                vat_no: "VAT01",
                bank_ac: "119874563210",
                sort_code: "123654789"
            },
            orderDetails: [{
                name: "Suraj Super Shopee",
                delivery_address: "Gaikwad Petrol Pump, Pune, E96 FZ",
                phone: "7276617342",
                email: "surajbang26@gmail.com",
                reference_no: "INV0015131",
                date: "16-10-2025",
                account_no: "0143",
                order_discount: 0,
                over_all_discount: 0,
                grand_total: 10.80
            }],
            product_details: [{
                product_code: "001",
                product_name: "Kettle Lightly Salted",
                size: "12x130g",
                order_type: "Box",
                quantity: "1",
                unit_price: "9.00",
                item_discount: "0.00",
                item_tax: "1.80",
                tax_rate_percent: "20",
                subtotal: "9.00"
            }]
        });
    };

    const generatePDF = () => {
        if (!invoiceData) return;

        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });

        const shop = invoiceData.shop_details;
        const order = invoiceData.orderDetails[0];
        const products = invoiceData.product_details;

        // Page dimensions
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const margin = 15;
        const contentWidth = pageWidth - (margin * 2);

        let yPos = margin;

        // Background color for header
        doc.setFillColor(244, 246, 248);
        doc.rect(margin, yPos, contentWidth, 65, 'F');

        // Border around header
        doc.setDrawColor(238, 238, 238);
        doc.rect(margin, yPos, contentWidth, 65, 'S');

        // Add logo placeholder (you can add actual logo using addImage)
        yPos += 8;
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text('[LOGO]', margin + 5, yPos);

        // Shop details
        const shopStartX = margin + 50;
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text(shop.shop_name, shopStartX, yPos);

        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        yPos += 4;
        doc.text(shop.address, shopStartX, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('Phone: ', shopStartX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(shop.phone, shopStartX + 12, yPos);

        doc.setFont('helvetica', 'bold');
        doc.text('Email: ', shopStartX + 40, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(shop.email, shopStartX + 50, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('Website: ', shopStartX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(shop.website, shopStartX + 16, yPos);

        doc.setFont('helvetica', 'bold');
        doc.text('Company No: ', shopStartX + 50, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(shop.company_reg_no, shopStartX + 70, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('VAT No: ', shopStartX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(shop.vat_no, shopStartX + 14, yPos);

        // Horizontal line
        yPos += 5;
        doc.setDrawColor(221, 221, 221);
        doc.line(margin + 5, yPos, margin + contentWidth - 5, yPos);

        // Customer and Invoice details section
        yPos += 8;

        // Customer details (left side)
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(order.name, margin + 5, yPos);

        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        yPos += 4;
        doc.text(order.delivery_address, margin + 5, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('Phone: ', margin + 5, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(order.phone, margin + 16, yPos);

        doc.setFont('helvetica', 'bold');
        doc.text('Email: ', margin + 45, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(order.email, margin + 56, yPos);

        // Invoice details (right side)
        const rightColX = pageWidth - margin - 60;
        yPos -= 8;
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Invoice No: ', rightColX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(order.reference_no, rightColX + 20, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('Order Date: ', rightColX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(order.date, rightColX + 20, yPos);

        yPos += 4;
        doc.setFont('helvetica', 'bold');
        doc.text('Account No: ', rightColX, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(order.account_no, rightColX + 20, yPos);

        // Calculate totals
        let itemTotal = 0;
        let totalVat = 0;
        let vatGoods = 0;
        let nonVatGoods = 0;

        products.forEach(product => {
            const subtotal = parseFloat(product.subtotal);
            const itemTax = parseFloat(product.item_tax);

            itemTotal += subtotal;
            totalVat += itemTax;

            if (parseFloat(product.tax_rate_percent) > 0) {
                vatGoods += subtotal;
            } else {
                nonVatGoods += subtotal;
            }
        });

        const orderDiscount = parseFloat(order.order_discount || 0);
        const overAllDiscount = parseFloat(order.over_all_discount || 0);
        const grandTotal = parseFloat(order.grand_total);

        // Products table
        yPos += 10;

        const tableData = products.map(product => [
            `${product.product_code} - ${product.product_name} - ${product.size}`,
            product.order_type,
            product.quantity,
            `£${parseFloat(product.unit_price).toFixed(2)}`,
            `£${parseFloat(product.item_discount || 0).toFixed(2)}`,
            `£${parseFloat(product.item_tax).toFixed(2)}`,
            `£${parseFloat(product.subtotal).toFixed(2)}`
        ]);

        doc.autoTable({
            startY: yPos,
            head: [['Product', 'Type', 'Qty', 'Unit Price', 'Discount', 'VAT', 'Net Amt']],
            body: tableData,
            theme: 'grid',
            headStyles: {
                fillColor: [244, 246, 248],
                textColor: [64, 64, 64],
                fontSize: 8,
                fontStyle: 'normal',
                halign: 'left'
            },
            bodyStyles: {
                fontSize: 8,
                textColor: [64, 64, 64]
            },
            columnStyles: {
                0: { cellWidth: 70 },
                1: { halign: 'center', cellWidth: 20 },
                2: { halign: 'center', cellWidth: 15 },
                3: { halign: 'right', cellWidth: 25 },
                4: { halign: 'right', cellWidth: 25 },
                5: { halign: 'right', cellWidth: 20 },
                6: { halign: 'right', cellWidth: 25 }
            },
            margin: { left: margin, right: margin }
        });

        yPos = doc.lastAutoTable.finalY;

        // Summary rows
        const summaryData = [
            ['', '', '', '', '', 'Item Total:', `£${itemTotal.toFixed(2)}`],
            [`NON VAT Goods - £${nonVatGoods.toFixed(2)} | VAT Goods - £${vatGoods.toFixed(2)}`, '', '', '', '', 'Total Vat:', `£${totalVat.toFixed(2)}`],
            ['', '', '', '', '', 'Order Discount(0%):', orderDiscount > 0 ? `£${orderDiscount.toFixed(2)}` : ' '],
            ['', '', '', '', '', 'Promo Discount:', overAllDiscount > 0 ? `£${overAllDiscount.toFixed(2)}` : ' '],
            ['', '', '', '', '', 'Total Amount:', `£${grandTotal.toFixed(2)}`]
        ];

        doc.autoTable({
            startY: yPos,
            body: summaryData,
            theme: 'grid',
            bodyStyles: {
                fillColor: [244, 246, 248],
                fontSize: 8,
                fontStyle: 'bold',
                textColor: [64, 64, 64]
            },
            columnStyles: {
                0: { cellWidth: 70 },
                1: { cellWidth: 20 },
                2: { cellWidth: 15 },
                3: { cellWidth: 25 },
                4: { cellWidth: 25 },
                5: { halign: 'right', cellWidth: 20 },
                6: { halign: 'right', cellWidth: 25 }
            },
            margin: { left: margin, right: margin }
        });

        yPos = doc.lastAutoTable.finalY + 10;

        // Signature section
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Good Received & Checked By:', margin + 5, yPos);
        doc.text('No of Boxes Received:', pageWidth - margin - 45, yPos);

        doc.setDrawColor(102, 102, 102);
        doc.setLineDash([2, 2]);
        doc.line(margin, yPos + 2, pageWidth - margin, yPos + 2);

        yPos += 8;
        doc.text('Amount Paid:', margin + 5, yPos);
        doc.text('Cash / Cheque Collected By:', pageWidth - margin - 58, yPos);
        doc.line(margin, yPos + 2, pageWidth - margin, yPos + 2);
        doc.setLineDash([]);

        // Bank details
        yPos += 10;
        doc.setFont('helvetica', 'normal');
        doc.text(`Bank Details: A/C No: ${shop.bank_ac} | Sort Code: ${shop.sort_code}`, margin + 5, yPos);

        // Terms
        yPos += 8;
        doc.setFont('helvetica', 'bold');
        doc.text('Terms:', margin + 5, yPos);

        doc.setFont('helvetica', 'normal');
        yPos += 5;
        const terms = [
            '• Once delivery is received is not responsible for any damage or loss',
            '• Goods remain the property of Ebusso until invoice fully paid',
            '• No claims for damages or short delivery will be considered unless made at the time of delivery',
            '• There is No Refund Policy of goods sold'
        ];

        terms.forEach(term => {
            doc.text(term, margin + 8, yPos);
            yPos += 5;
        });

        // Note section
        yPos += 3;
        doc.setFont('helvetica', 'bold');
        doc.text('Note:', margin + 5, yPos);

        doc.setDrawColor(238, 238, 238);
        doc.rect(margin + 5, yPos + 2, contentWidth - 10, 25, 'S');

        doc.output('dataurlnewwindow');
    };

    return (
        <div className="min-vh-100 bg-light d-flex align-items-center justify-content-center">
            <div className="text-center">
                <div className="spinner-border text-primary" style={{ width: '4rem', height: '4rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-4 text-secondary fs-5 fw-medium">
                    {loading ? 'Loading invoice data...' : 'Generating PDF...'}
                </p>
            </div>
        </div>
    );
};

export default SalesInvoice;